import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './InactivityWarning.css';

interface InactivityWarningProps {
  visible: boolean;
  secondsRemaining: number;
  onStayActive: () => void;
}

const InactivityWarning: React.FC<InactivityWarningProps> = ({ 
  visible, 
  secondsRemaining,
  onStayActive 
}) => {
  return (
    <Dialog
      visible={visible}
      modal
      closable={false}
      onHide={() => {}} // Required by PrimeReact
      style={{ width: '450px' }}
      className="inactivity-warning-dialog"
    >
      <div className="inactivity-warning-content">
        <div className="warning-icon">
          <i className="pi pi-exclamation-triangle"></i>
        </div>
        
        <h2>Inactivity Detected</h2>
        
        <p className="warning-message">
          You will be signed out automatically in <strong>{secondsRemaining}</strong> seconds due to inactivity.
        </p>
        
        <div className="warning-actions">
          <Button
            label="Stay Signed In"
            icon="pi pi-check"
            onClick={onStayActive}
            className="p-button-success"
            autoFocus
          />
        </div>
      </div>
    </Dialog>
  );
};

export default InactivityWarning;

